import { render, staticRenderFns } from "./selectOfModalTable.vue?vue&type=template&id=37deb73c&scoped=true"
import script from "./selectOfModalTable.vue?vue&type=script&lang=js"
export * from "./selectOfModalTable.vue?vue&type=script&lang=js"
import style0 from "./selectOfModalTable.vue?vue&type=style&index=0&id=37deb73c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37deb73c",
  null
  
)

export default component.exports